/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { SomniaTokenSummaryInfo } from './SomniaTokenSummaryInfo';

export type SomniaTokenInfo = {
    ADDR: SomniaTokenSummaryInfo;
    TKNT: SomniaTokenInfo.TKNT;
    PRC: string;
    PRC24H: string;
    MKC: string;
    VOL24H: string;
    HD: string;
    HD24H: string;
    TSP: string;
};

export namespace SomniaTokenInfo {

    export enum TKNT {
        NA = 'NA',
        CA = 'CA',
        ERC20 = 'ERC20',
        ERC721 = 'ERC721',
        ERC1155 = 'ERC1155',
    }


}

